import {
  queryStaffApi,
  getBrandListApi,
  getShopListApi,
  getRoleListApi,
  addRoleApi,
  updateRoleApi,
  getRoleByIdApi,
  getDictionaryListApi,
  deleteRoleApi,
  addStaffApi,
  updateStaffApi,
  getStaffByIdApi,
  setStaffApi,
  deleteStaffApi,
  resetStaffPasswordApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  查询员工列表信息接口
  async queryStaffAction(context, param) {
    const res = await queryStaffApi(param)
    return res
  },
  //  查询员工列表信息接口
  async getBrandListAction(context, param) {
    const res = await getBrandListApi(param)
    return res
  },
  //  查询门店列表
  async getShopListAction(context, param) {
    const res = await getShopListApi(param)
    return res
  },
  // 获取角色列表信息
  async getRoleListAction(context, param) {
    const res = await getRoleListApi(param)
    return res
  },
  // 添加角色信息
  async addRoleAction(context, param) {
    const res = await addRoleApi(param)
    return res
  },
  // 修改角色信息
  async updateRoleAction(context, param) {
    const res = await updateRoleApi(param)
    return res
  },
  // 根据id获得角色信息
  async getRoleByIdAction(context, param) {
    const res = await getRoleByIdApi(param)
    return res
  },
  // 获取字典列表信息
  async getDictionaryListAction(context, param) {
    const res = await getDictionaryListApi(param)
    return res
  },
  // 删除角色信息
  async deleteRoleAction(context, param) {
    const res = await deleteRoleApi(param)
    return res
  },
  // 添加员工信息
  async addStaffAction(context, param) {
    const res = await addStaffApi(param)
    return res
  },
  // 修改员工信息
  async updateStaffAction(context, param) {
    const res = await updateStaffApi(param)
    return res
  },
  // 获取员工详情
  async getStaffByIdAction(context, param) {
    const res = await getStaffByIdApi(param)
    return res
  },
  // 设置员工状态
  async setStaffAction(context, param) {
    const res = await setStaffApi(param)
    return res
  },
  // 删除员工
  async deleteStaffAction(context, param) {
    const res = await deleteStaffApi(param)
    return res
  },
  // 重置员工密码
  async resetStaffPasswordAction(context, param) {
    const res = await resetStaffPasswordApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
